import React, { useEffect, useState } from 'react'
import SwaggerUI from "swagger-ui-react"
import "swagger-ui-react/swagger-ui.css"
import { Box, MenuItem, TextField, Typography } from '@material-ui/core'
import Breadcrumb from '../../Components/Breadcrumbs'
import { DisplayMessage, Loader } from '../../Components'
import { useStyles } from './style'
import * as messageTypes from '../../utils/messageTypes'
import axios from 'axios'
import _ from 'lodash'
import Urls from '../../utils/publicApiUrlStrings'
import betaTag from '../../Assets/Icons/betaTag.png'

function CloudApi() {
  const classes = useStyles()
  const [loading, setLoading] = useState(true)
  const [json, setJson] = useState()
  const [callCount, setCallCount] = useState(1)
  const [open, setOpen] = useState(false)
  const [message, setMessage] = useState()
  const [messageType, setMessageType] = useState()
  const [version, setVersion] = useState('1.1.0')

  const getSwaggerData = () => {
    setLoading(true)
    axios.get(Urls.getApiUrl(`getApiSpec`))
      .then(jsonData => {
        let swaggerData = { ...jsonData.data }
        swaggerData.host = ""
        swaggerData.basePath = ""
        if (swaggerData.info) {
          swaggerData.info.description = ""
          swaggerData.info.title = ""
          swaggerData.info.version = ""
        }
        setJson(swaggerData)
        setLoading(false)
      })
      .catch(error => {
        if (error.response.status === 500 && callCount <= 5) {
          getSwaggerData()
          setCallCount(count => count + 1)
        } else {
          setLoading(false)
          setOpen(true)
          setMessage(_.get(error, 'data.error.displayMessage', 'Something went wrong'))
          setMessageType(messageTypes.ERROR)
        }
      })
  }

  useEffect(() => {
    getSwaggerData()
  }, [])

  useEffect(() => {
    if (json) {
      const waitForForecastTag = (attempt = 0, maxAttempts = 20) => {
        
        const tagElements = document.querySelectorAll('.opblock-tag')
        let forecastFound = false
        
        tagElements.forEach(tagElement => {
          const tagText = tagElement.querySelector('span')
          if (tagText && tagText.textContent.includes('Forecast')) {
            forecastFound = true
            const existingBetaTag = tagElement.querySelector('.beta-tag-img')
            if (!existingBetaTag) {
              const betaImg = document.createElement('img')
              betaImg.src = betaTag
              betaImg.className = 'beta-tag-img'
              betaImg.style.width = '70px'
              betaImg.style.height = '50px'
              betaImg.style.verticalAlign = 'middle'
              tagText.appendChild(betaImg)
            }
          }
        })
        
        if (!forecastFound && attempt < maxAttempts) {
          setTimeout(() => {
            waitForForecastTag(attempt + 1, maxAttempts)
          }, 200)
        } else if (!forecastFound) {
          console.warn('Forecast tag not found after maximum attempts')
        }
      }

      waitForForecastTag()
    }
  }, [json])

  return (
    <>
      <Breadcrumb value={[{ 'Developer Hub': '/developer' }, { 'Cloud API': '/developer/cloud-api' }]} />
      <DisplayMessage open={open} message={message} messageType={messageType} handleClose={() => setOpen(false)} />
      <Loader loading={loading} />
      <Box className={classes.headerWrapper}>
        <Box my={1}>
          <Typography className={classes.title}>Cloud API</Typography>
          <Box className={classes.subTitle}>Integrate the VPP API into your application</Box>
        </Box>
        <TextField
          select
          value={version}
          label="Version"
          fullWidth
          style={{ maxWidth: 150 }}
          InputProps={{
            classes: { root: classes.input }
          }}
          SelectProps={{
            MenuProps: {
              classes: { paper: classes.paper },
              anchorOrigin: {
                vertical: "bottom",
                horizontal: "left"
              },
              getContentAnchorEl: null
            }
          }}
          onChange={(e) => setVersion(e.target.value)}
        >
          <MenuItem value="1.1.0">1.1.0</MenuItem>
        </TextField>
      </Box>
      <Box className={classes.swaggerWrapper}>
        {json && <SwaggerUI spec={json} supportedSubmitMethods={[]} tryItOutEnabled={false} docExpansion="none" />}
        {!json && !loading && <Box className={classes.failedWrapper} mt={1}><Typography className={classes.failedText}>Failed to load Cloud API</Typography></Box>}
      </Box>
    </>
  )
}

export default CloudApi